// Types
import type { TTextAreaProps, TTextAreaSize, TTextAreaStatus, TTextAreaVariant } from './TextArea.type';

export const TEXT_AREA_SIZES: TTextAreaSize[] = ['sm', 'md', 'lg'];
export const TEXT_AREA_SIZE: { [key in TTextAreaSize]: key } = {
	sm: 'sm',
	md: 'md',
	lg: 'lg',
};

export const TEXT_AREA_STATUSES: TTextAreaStatus[] = ['default', 'error', 'success'];
export const TEXT_AREA_STATUS: { [key in TTextAreaStatus]: key } = {
	default: 'default',
	error: 'error',
	success: 'success',
};

export const TEXT_AREA_VARIANTS: TTextAreaVariant[] = ['inline', 'outline'];
export const TEXT_AREA_VARIANT: { [key in TTextAreaVariant]: key } = {
	inline: 'inline',
	outline: 'outline'
};

export const TEXT_AREA_DEFAULT_PROPS: TTextAreaProps = {
	size: TEXT_AREA_SIZE.md,
	status: TEXT_AREA_STATUS.default,
	variant: TEXT_AREA_VARIANT.outline,
};
